import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '../../../services/dashboardService';
import { useSessionGate } from '../../../hooks/useSessionGate';

export const useDashboardStats = () => {
  const { expired } = useSessionGate();
  const statsQuery = useQuery({
    queryKey: ['dashboard-stats'],
    queryFn: () => dashboardService.getStats(),
    enabled: !expired,
  });

  const stats = statsQuery.data?.data || null;

  return {
    stats,
    isLoading: statsQuery.isLoading,
    error: statsQuery.error,
  };
};

export const useDashboardChart = (period: number = 30, domainId?: string | null) => {
  const { expired } = useSessionGate();
  const chartQuery = useQuery({
    queryKey: ['dashboard-chart', period, domainId ?? null],
    queryFn: () => dashboardService.getChart(period, domainId),
    enabled: !expired,
  });

  return {
    chartData: chartQuery.data?.data || null,
    isLoading: chartQuery.isLoading,
    error: chartQuery.error,
  };
};
